export const Urls = {
  academyLogin: "http://academy.traingrc.com/login",
};
